// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"a0-z","subtitle":"b0-z","wrapper":"c0-z","leftArrow":"d0-z","rightArrow":"e0-z"};